<div
  class="flex h-[40px] max-w-sm cursor-pointer flex-row items-center gap-2 overflow-hidden rounded-md bg-[#f4c018] px-2 py-1 text-sm text-white hover:bg-amber-300"
  matRipple
  matRippleColor="#f4c01866"
  [matTooltip]="tooltip()"
  (click)="action.emit()"
>
  <mat-icon class="shrink-0">campaign</mat-icon>
  @if (label(); as label) {
    <div class="flex grow truncate">{{ label }}</div>
  }
</div>
